import s from "./InputSearchCollapsible.module.scss";
import { IconImage } from "@/components/UI/IconImage";
import { FormEvent, MouseEvent, useEffect, useState } from "react";
import cn from "classnames";

type InputSearchCollapsibleProps = {
  onToggle?: (value: boolean) => void;
  onSubmit?: (value: string) => void;
  collapsible?: boolean;
};

export const InputSearchCollapsible = ({
  onToggle,
  onSubmit,
  collapsible = true,
}: InputSearchCollapsibleProps) => {
  const [value, setValue] = useState("");
  const [open, setOpen] = useState<boolean>(false);

  const handleButtonClick = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmedValue = value.trim();
    if (open) {
      if (trimmedValue) {
        onSubmit?.(trimmedValue);
      } else {
        setOpen(false);
      }
    } else {
      setOpen(true);
    }
  };

  useEffect(() => {
    onToggle?.(open);
  }, [onToggle, open]);

  return (
    <div
      className={cn(s.wrapper, {
        [s.open]: open,
        [s.noCollapse]: !collapsible,
      })}
    >
      <form onSubmit={handleButtonClick}>
        <input
          type="search"
          name="search"
          className={s.input}
          placeholder="I’m searching for..."
          value={value}
          onChange={(event) => setValue(event.target.value)}
        />
        <button className={s.button} type="submit">
          <IconImage size={24} icon="magnifying-glass" />
        </button>
      </form>
    </div>
  );
};
